import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Accordion } from '@mantine/core';
import SidebarNavButton from './SidebarNavButton';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';

const SidebarNavSections = ({ sections, state }) => {
  const { pathname } = useLocation();
  const { state: authState } = useContext(AuthContext);

  return sections.map((section) => {
    const isSelected = section.isSelected(pathname, state, authState);
    const selectedSectionLinkIndex = section.links?.findIndex((link) =>
      link.isSelected(pathname, state, authState)
    );
    const navigationLinks =
      section.links?.filter((link) =>
        link.isVisible ? link.isVisible(state, authState) : true
      ) || [];

    return (
      <Accordion
        key={section.to}
        onChange={() => {}}
        style={{ border: 'none', padding: 0 }}
        styles={{
          label: { padding: 0 },
          chevron: { display: 'none' },
          control: { padding: 0 },
          content: { padding: 0 },
          item: { border: 'none' }
        }}
        value={isSelected || selectedSectionLinkIndex >= 0 ? section.to : null}
      >
        <Accordion.Item value={section.to}>
          <Accordion.Control>
            <SidebarNavButton
              key={section.to}
              color="#000"
              IconComponent={section.icon}
              innerSelected={selectedSectionLinkIndex >= 0}
              isSelected={isSelected}
              label={section.title}
              link={section.to}
              rightSection={
                section.getRightSection
                  ? section.getRightSection(state, pathname)
                  : null
              }
            />
          </Accordion.Control>
          {navigationLinks && navigationLinks.length > 0 && (
            <Accordion.Panel>
              {navigationLinks.map((link, index) => (
                <Accordion
                  key={link.to}
                  onChange={() => {}}
                  style={{ border: 'none', padding: 0 }}
                  styles={{
                    label: { padding: 0 },
                    chevron: { display: 'none' },
                    control: { padding: 0 },
                    content: { padding: 0 },
                    item: { border: 'none' }
                  }}
                  value={null}
                >
                  <Accordion.Item value={section.to}>
                    <Accordion.Control>
                      <SidebarNavButton
                        IconComponent={link.icon}
                        innerSelected={index < selectedSectionLinkIndex}
                        isSelected={link.isSelected(pathname)}
                        label={link.title}
                        link={link.to}
                        rightSection={
                          link.getRightSection
                            ? link.getRightSection(state, pathname)
                            : null
                        }
                      />
                    </Accordion.Control>
                  </Accordion.Item>
                </Accordion>
              ))}
            </Accordion.Panel>
          )}
        </Accordion.Item>
      </Accordion>
    );
  });
};

SidebarNavSections.propTypes = { sections: PropTypes.array };

export default SidebarNavSections;
